import React, { useContext } from "react";
import styles from "./styles.module.scss";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { formatMoney, truncateStringEllipsis } from "../../utils/helpers";
import AppContext from "../../hooks/appContext";
import Image from "next/image";

const CartItem = (props) => {

  const addQuantity = (product) => {
    props.addQty(product)
  }

  const reduceQuantity = (product) => {
    props.reduceQty(product)
  }

  const removeItem = (product) => {
    props.removeItem(product)
  }

  const {
    currentCurrency,
    activeAttributes,
  } = useContext(AppContext);

  const findVariantAmounts = () => {
    if (!props?.product?.variants.length > 0) {
      return (props.price * props?.product.qty) / 100;
    }

    const matchingObject = props?.product.variants.find(obj =>
      props?.product?.matchingVariant?.every(option =>
        obj.options?.some(
          opt => opt.label === option.label && opt.value === option.value
        )
      )
    );

    return ((matchingObject?.amounts?.find((obj) => obj.currency_id === currentCurrency).amount * props?.product.qty) / 100);

  }

  return (
    <>
      <div className={styles['cart-item-card']}>
        <div className={styles['item-card-info']}>
          <Image alt="" width="60" height="40" src={props.image} className={styles['cart-item-image']} />

          <div className={styles['cart-item-details']}>
            <p className={styles['cart-item-name']}>
              {truncateStringEllipsis(props.name, 24)}
              {props.product?.matchingVariant?.length > 0 ? " [" : null}
              {props.product?.matchingVariant?.map((variant) => variant.value).join(', ')}
              {props.product?.matchingVariant?.length > 0 ? "]" : null}
            </p>
            <p
              className={styles['cart-item-price']}>
              {currentCurrency === 'NGN' ? <span dangerouslySetInnerHTML={{ __html: "&#8358;" }}></span> : '$'}
              {formatMoney(findVariantAmounts())}
            </p>
          </div>
        </div>

        <div className={styles['cart-item-actions']}>
          {
            props.itemSource === "favorites" ?
              <button type='button' className={styles.btn_add_to_cart} onClick={() => addQuantity(props.product)}>Add to cart</button>
              :
              <div className={styles['item-math']}>
                <div className={styles['item-minus']} onClick={() => reduceQuantity(props.product)}><RemoveIcon /></div>
                <div className={styles['item-qty']}>{props.qty}</div>
                <div className={styles['item-plus']} onClick={() => addQuantity(props.product)}><AddIcon /></div>
              </div>
          }


          <div className={styles['item-remove']} onClick={() => removeItem(props.product)}><DeleteOutlineIcon /></div>
        </div>
      </div>
    </>
  )
}

export default CartItem